import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatDialogModule } from "@angular/material/dialog";
import { TaskScheduleQueryDisplayComponent } from "@app2/alert/task-schedule-query-display.component";
import { SharedModule } from "@app2/shared/shared.module";
import { TaskScheduleEmbeddedListComponent } from "@app2/task-schedules/task-schedule-embedded-list.component";
import { TaskScheduleListModalComponent } from "@app2/task-schedules/task-schedule-list.component";
import {
    TaskScheduleSearchableEmbeddedListComponent
} from "@app2/task-schedules/task-schedule-searchable-embedded-list.component";
import { TaskScheduleComponent } from "@app2/ticket/task-schedule.component";
import {
    ParentAndSubschedulesComponent
} from "@app2/task-schedules/task-schedule-view-page/parent-and-subschedules.component";
import { QueryListComponent } from "@app2/task-schedules/query-list.component";
import { SearchSharedModule } from "@app2/search/search-shared/search-shared.module";
import {
    TaskScheduleDueDisplayComponent
} from "@app2/task-schedules/task-schedule-view-page/task-schedule-due-display.component";
import { TaskScheduleDueDateSectionComponent } from "@app2/task-schedules/task-schedule-due-date-section.component";
import {
    TaskScheduleSavedQueriesSectionComponent
} from "@app2/task-schedules/task-schedule-saved-queries-section.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatDialogModule,
        SharedModule,

        SearchSharedModule,
    ],
    declarations: [
        QueryListComponent,
        ParentAndSubschedulesComponent,
        TaskScheduleComponent,
        TaskScheduleDueDisplayComponent,
        TaskScheduleDueDateSectionComponent,
        TaskScheduleEmbeddedListComponent,
        TaskScheduleQueryDisplayComponent,
        TaskScheduleSavedQueriesSectionComponent,
        TaskScheduleSearchableEmbeddedListComponent,

        // Modals
        TaskScheduleListModalComponent,
    ],
    exports: [
        QueryListComponent,
        ParentAndSubschedulesComponent,
        TaskScheduleComponent,
        TaskScheduleDueDisplayComponent,
        TaskScheduleDueDateSectionComponent,
        TaskScheduleEmbeddedListComponent,
        TaskScheduleQueryDisplayComponent,
        TaskScheduleSavedQueriesSectionComponent,
        TaskScheduleSearchableEmbeddedListComponent,
    ],
})
export class TaskSchedulesSharedModule {
    constructor() {
    }
}
